import { companySideAreaCalls } from './calls.mapper';
import { companySideAreaContacts } from './contacts.mapper';
import { companySideAreaDocuments } from './documents.mapper';
import { companySideAreaGroups } from './groups.mapper';
import { companySideAreaObjections } from './objections.mapper';
import { companySideAreaParams } from './params.mapper';

export function mapCompanyToSideArea(company, { onEditWorth } = {}) {
	if (!company) return {};

	const linkedGroups = companySideAreaGroups(company);

	return {
		label: company.name,
		items: [
			...linkedGroups,
			!company.isGroup && companySideAreaParams(company, { onEditWorth }),
			companySideAreaObjections(company),
			companySideAreaContacts(company),
			companySideAreaCalls(company),
			companySideAreaDocuments(company),
		].filter(Boolean),
	};
}
